import React from 'react';
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ErrorIcon from '@mui/icons-material/Error';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {Link as RouterLink} from "react-router-dom";

const Four04Page = () => {
    return (
        <Box
            component="main"
            sx={{
                alignItems: 'center',
                display: 'flex',
                flexGrow: 1,
                minHeight: '100%',
                marginTop: "20%"
            }}
        >
            <Container maxWidth="md">
                <Box
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >

                    <Box sx={{textAlign: 'center'}}>
                        <ErrorIcon sx={{fontSize: 60, color: "error.dark"}}/>
                    </Box>
                    <Typography
                        align="center"
                        color="textPrimary"
                        variant="h5"
                    >
                        404: The page you are looking for isn’t here
                    </Typography>
                    <Typography
                        align="center"
                        component="div"
                        variant="subtitle2"
                    >
                        You either tried some shady route or you came here by mistake.
                        Whichever it is, try using the navigation
                    </Typography>
                    <Button
                        component={RouterLink} to={"/"}
                        href={"/"}
                        startIcon={(<ArrowBackIcon fontSize="small"/>)}
                        sx={{mt: 3}}
                        variant="contained"
                    >
                        Go back
                    </Button>
                </Box>
            </Container>
        </Box>
    );
};

export default Four04Page;